import dayjs from "dayjs"

const LABEL_FUNDING_PASSED = `Your funding is incomplete. Please be aware that
the funding deadline has passed. Make a wire transfer to proceed.`

const LABEL_NO_BANK_ACCOUNT = `Bank account details are not yet available. We
will notify you when they're ready so you can complete your investment process.`

const LABEL_FUNDING_PENDING = `Your electronic transfer is pending. Your funds
will most likely arrive by [DATE].`

const LABEL_FUNDING_SDIRA_PENDING = `Your funding is being processed. The process will be marked as complete, and you will receive a confirmation email once your sponsor has confirmed the receipt of the funds.`

const LABEL_FUNDING_COMPLETE = `Success! Your funding is complete. Thank you
for your investment.`

const LABEL_FUNDING_OVERFUNDED = `You've sent more funds than your committed
amount. Please contact support for assistance.`

const LABEL_FUNDING_INCOMPLETE_ACH = `Your funding is incomplete. Click the
"Send Funds" button or make a wire transfer to proceed.`

const LABEL_FUNDING_INCOMPLETE_WIRE = `Your funding is incomplete. Click
"View Wire Instructions" to view and download the wire instructions to initiate
a wire to fund your investment.`

const LABEL_SDIRA_FUNDING_INCOMPLETE = `Please provide your custodian with the
wire transfer instructions to complete the funding process.`

const LABEL_FUNDING_PARTIALLY_FUNDED = `Received amount doesn't match the
committed amount. Add funds via wire transfer to match your commitment or
contact support for assistance.`

const LABEL_FUNDING_CONNECT = `Your funding is incomplete. Click "Connect" to
begin the process to electronically fund via ACH.

Alternatively, if you prefer to send funds manually via wire, click "Connect"
and "View and Download Wiring Instructions" to download the wiring instructions
and send your investment through a wire transfer.`

const LABEL_SUSPENDED = `Identity verification did not succeed. Please click
"View and Download Wiring Instructions" to download the wiring instructions and
send your investment through a wire transfer.`

const LABEL_INSUFFICIENT_FUNDS_INVESTOR_BANK_ACCOUNT = `The bank account
initially linked does not have sufficient funds. Please add funds to the bank
account or connect a new funding bank account. Once the issue is addressed,
click "Send Funds" to initiate your investment funds transfer to the
[ORGANIZATION_NAME] bank account.
`
const LABEL_INVALID_INVESTOR_BANK_ACCOUNT = `The bank account initially linked
is invalid and funds have not been debited from your account. Please connect a
new valid funding bank account. Once you have connected a new valid funding bank
account, click "Send Funds" to initiate your investment funds transfer to the
[ORGANIZATION_NAME] bank account.` // R03 - investor
const getSubtitle = ({
  isInvestmentCustomerSuspended,
  isOverfunded,
  isComplete,
  isPartiallyFunded,
  isPending,
  isTargetDatePassed,
  hasBankAccount,
  isSdira,
  shouldRenderWireInstructions,
  hasNoSenderSource,
  fundsSentAt,
  organizationName,
  isInvalidInvestorBankAccount,
  isInsufficientFundsInvestorBankAccount,
}) => {
  if (isInvestmentCustomerSuspended) {
    return LABEL_SUSPENDED
  }

  if (isInvalidInvestorBankAccount) {
    return LABEL_INVALID_INVESTOR_BANK_ACCOUNT.replace('[ORGANIZATION_NAME]', organizationName)
  }

  if (isInsufficientFundsInvestorBankAccount) {
    return LABEL_INSUFFICIENT_FUNDS_INVESTOR_BANK_ACCOUNT.replace('[ORGANIZATION_NAME]', organizationName)
  }

  if (isOverfunded) {
    return LABEL_FUNDING_OVERFUNDED
  }

  if (isComplete) {
    return  LABEL_FUNDING_COMPLETE
  }

  if (isPartiallyFunded) {
    return LABEL_FUNDING_PARTIALLY_FUNDED
  }

  if (isPending) {
    let label = fundsSentAt
      ? LABEL_FUNDING_PENDING.replace('[DATE]', dayjs(fundsSentAt).add(9, 'day').format('MM/DD/YYYY'))
      : LABEL_FUNDING_PENDING.replace('by [DATE]', 'in 7 business days')

    if (isSdira) {
      label = LABEL_FUNDING_SDIRA_PENDING
    }

    return label
  }

  if (isTargetDatePassed) {
    return LABEL_FUNDING_PASSED
  }

  if (!hasBankAccount) {
    return LABEL_NO_BANK_ACCOUNT
  }

  if (isSdira) {
    return LABEL_SDIRA_FUNDING_INCOMPLETE
  }

  if (shouldRenderWireInstructions) {
    return LABEL_FUNDING_INCOMPLETE_WIRE
  }

  if (hasNoSenderSource) {
    return LABEL_FUNDING_CONNECT
  }

  return LABEL_FUNDING_INCOMPLETE_ACH
}

export default getSubtitle
